import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-600">关于耽耽漫画的常见疑问，这里都有答案</p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqItems.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-xl md:rounded-2xl p-5 md:p-6 border border-background-200/70">
              <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-3 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line w-5 h-5 flex items-center justify-center"></i>
                </span>
                {item.question}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-8">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}